import styled from "@emotion/styled";

export const ZoomSliderWrapper = styled.div`
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  display: flex;
  justify-content: center;
`

export const SlidersLabels = styled.label`
  color: #3c4043;
  display: flex;
  flex-direction: column-reverse;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  margin: 0;
  opacity: 1;
  text-transform: none;
`

export const ZoomSlider = styled.input`
  -webkit-appearance: none;
  cursor: pointer;
  height: 25px;
  margin: 10px 0;
  width: 100%;


  &:focus{
    outline: none;
    &::-webkit-slider-runnable-track {
      background: #2497E3;
    }
  }

  &::-webkit-slider-runnable-track {
    animate: 0.2s;
    background: #2497E3;
    border: 0px solid #000000;
    border-radius: 4px;
    box-shadow: 0px 0px 0px #000000;
    cursor: pointer;
    height: 5px;
    width: 100%;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #A1D0FF;
    border: 1px solid #2497E3;
    border-radius: 25px;
    box-shadow: 0px 0px 0px #000000;
    cursor: pointer;
    height: 18px;
    margin-top: -7px;
    width: 18px;
  }
`

export const ZoomSliderTextWrapper = styled.div<{colorContrast:string}>`
  background: ${({ colorContrast }) => (colorContrast)};
  border-radius: 8px;
  height: 38px;
  margin: 32px 4px 0;
  text-align: center;
  width: 38px;
`

export const ZoomSliderText = styled.p`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  line-height: 38px;
  margin: 0;
  opacity: 1;
  text-transform: none;
`